import { BaseDynamicFormElement } from './dynamic-form-base.class';
import { BaseDynamicFormElementInterface } from './base-dynamic-form-element.interface';

export class DatepickerElement extends BaseDynamicFormElement<Date> {
  constructor(config: Partial<BaseDynamicFormElementInterface<Date>>) {
    super({
      ...config,
      controlType: 'datepicker',
    });
  }
}
